import React from "react"

const GuideAccordion = ({ contentArea, text }) => {
  function showHideContent(event, classname) {
    let elem = event.currentTarget
    elem.__toggle = !elem.__toggle
    let target = elem.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
    }
  }

  const AccordionItem = ({ item, index }) => {
    return (
      <div className="accordion-item" onClick={(e) => showHideContent(e, ".contentWrapper")}>
        <div className="item-info">
          <div className="number-container">
            <div className="number" data-number={index + 1}></div>
          </div>
          <div className="headline" dangerouslySetInnerHTML={{ __html: item.headline }}></div>
        </div>
        <div className="contentWrapper show-hide">
          <div className="spacer">
            {item.image ? <img className="guide-item-image" src={item.image} alt="" /> : ""}
            <div className="guide-item-text" dangerouslySetInnerHTML={{ __html: item.text }}></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="guide-accordion-wrapper">
      <div className="w--wider">
        <div className="guide-text" dangerouslySetInnerHTML={{ __html: text }}></div>
        <div className="guide-accordion">
          {contentArea?.length > 0 &&
            contentArea.map((item, index) => {
              return <AccordionItem key={index} item={item} index={index} />
            })}
        </div>
      </div>
    </div>
  )
}

export default GuideAccordion
